export const ALL_CONTENT_GET_ALL_SUCCESS = 'ALL_CONTENT_GET_ALL_SUCCESS';
export const ALL_CONTENT_GET_ALL_FAILURE = 'ALL_CONTENT_GET_ALL_FAILURE';
export const ALL_CONTENT_DATA_IS_LOADING = 'ALL_CONTENT_DATA_IS_LOADING';
